// Qué salió de tus operaciones encubiertas y de las que sufres — español.
// Se une en ./messages.ts.

export const gameOpNewsEs = {
  'espionage.news.mine.sabotage.success': 'Tu sabotaje salió bien.',
  'espionage.news.mine.sabotage.seen': 'Tu sabotaje falló y vieron a tu agente.',
  'espionage.news.mine.sabotage.lost': 'Tu sabotaje falló y tu agente se perdió.',
  'espionage.news.mine.sabotage.quiet': 'Tu sabotaje falló y nadie se enteró.',
  'espionage.news.mine.assassination.success': 'El real ha muerto.',
  'espionage.news.mine.assassination.seen': 'El golpe falló y vieron a tu asesino.',
  'espionage.news.mine.assassination.lost': 'El golpe falló y tu asesino se perdió.',
  'espionage.news.mine.assassination.quiet': 'El golpe falló y nadie se enteró.',
  'espionage.news.mine.poison.success': 'El suministro está envenenado.',
  'espionage.news.mine.poison.seen': 'El envenenamiento falló y vieron a tu agente.',
  'espionage.news.mine.poison.lost': 'El envenenamiento falló y tu agente se perdió.',
  'espionage.news.mine.poison.quiet': 'El envenenamiento falló y nadie se enteró.',
  'espionage.news.mine.intercept.seen': 'El agente se escabulló antes de que pudieras atraparlo.',
  'espionage.news.mine.intercept.lost': 'Atrapaste a un agente extranjero.',
  'espionage.news.theirs.sabotage.blamed': 'Sabotaje en tu ciudad. Culpas a {house}.',
  'espionage.news.theirs.sabotage.unknown': 'Sabotaje en tu ciudad. Nadie sabe de quién.',
  'espionage.news.theirs.sabotage.caught': 'Atraparon a un saboteador: lo envió {house}.',
  'espionage.news.theirs.assassination.blamed': 'Ha muerto un real de tu casa. Culpas a {house}.',
  'espionage.news.theirs.assassination.unknown':
    'Ha muerto un real de tu casa. Nadie sabe quién fue.',
  'espionage.news.theirs.assassination.caught': 'Atraparon a un asesino: lo envió {house}.',
  'espionage.news.theirs.poison.blamed': 'Tus suministros están envenenados. Culpas a {house}.',
  'espionage.news.theirs.poison.unknown':
    'Tus suministros están envenenados. Nadie sabe quién fue.',
  'espionage.news.theirs.poison.caught': 'Atraparon a un envenenador: lo envió {house}.',
  'espionage.news.theirs.intercept.caught': 'Una guardia extranjera capturó a tu agente.',
  'espionage.news.framed.sabotage': 'Te culparon de un sabotaje. No tuviste parte.',
  'espionage.news.framed.assassination': 'Te culparon de un asesinato. No tuviste parte.',
  'espionage.news.framed.poison': 'Te culparon de un envenenamiento. No tuviste parte.',
} as const;
